import { SubmitToSandboxPanelController } from '../controller/SubmitToSandboxPanelController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';

export class SubmitToSandboxPanelWebComponent extends BaseWebComponentElement {
  public apiClientInjectedFromNirvana = false;
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: SubmitToSandboxPanelController,
    });
  }
}
